import type { CleanUpResult } from "../../../types";
import styles from "./ColourToolsPanel.module.css";

interface CleanUpStylingProps {
  readonly open: boolean;
  readonly onToggle: () => void;
  readonly busy: boolean;
  readonly onCleanUp: () => void;
  readonly cleanUpResult: CleanUpResult | null;
}

/** Collapsible "Clean Up Styling" card — extracted from ColourToolsPanel so
 * it stays focused on composition/layout; this owns no state of its own. */
export function CleanUpStyling({
  open,
  onToggle,
  busy,
  onCleanUp,
  cleanUpResult,
}: Readonly<CleanUpStylingProps>) {
  return (
    <div className={styles.card}>
      <button
        type="button"
        className={styles.collapseToggle}
        onClick={onToggle}
        aria-expanded={open}
        data-testid="cleanup-toggle"
      >
        <span className={styles.sectionHeading}>Clean Up Styling</span>
        <span
          className={`${styles.collapseChevron} ${open ? styles.collapseChevronOpen : ""}`}
        >
          ▼
        </span>
      </button>

      {open && (
        <div className={styles.section}>
          <span className={styles.hint}>
            Removes redundant inline overrides and standardises shape styles
            to match the theme.
          </span>
          <button
            type="button"
            className={styles.btnPrimary}
            onClick={onCleanUp}
            disabled={busy}
            data-testid="cleanup-run"
          >
            {busy ? "Working…" : "Run Clean Up"}
          </button>
          {cleanUpResult && (
            <div className={styles.cleanUpResult}>
              {cleanUpResult.message ?? "Clean up complete."}
              {typeof cleanUpResult.shapesFixed === "number" && (
                <> ({cleanUpResult.shapesFixed} shapes fixed)</>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
